import React from 'react';
import { ErrorState } from '../../../../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Card } from '../../../../../../CommonComponents/OPL/Card/Card';
import { FullPageLoading } from '../../../../../../CommonComponents/OPL/FullpageLoading/FullPageLoading';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { LegendKey } from '../../../../../../CommonComponents/OPL/charts/LegendKey/LegendKey';
import Spinner from '../../../../../../CommonComponents/Spinner';
import { useFinancialPlanQuery } from '../../../../../api/useFinancialPlanQuery';
import { Explanations } from '../../../../components/Explanations/Explanations';
import { useChartReflow } from '../../../../hooks/useChartReflow';
import { useRouteParams } from '../../../../hooks/useRouteParams';
import { CharitableGivingTab } from '../../CharitableGiving.types';
import { CharitableGivingChart } from '../../components/CharitableGivingChart/CharitableGivingChart';

export const Overview = () => {
  const { data, isLoading, isFetching, isError, refetch } = useFinancialPlanQuery();

  const { chartRef } = useChartReflow();

  if (isLoading) {
    return <FullPageLoading text="Loading..." size="medium" />;
  }

  if (isError) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" mt="56">
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  if (!data) {
    throw new Error('No data for the charitable giving chart');
  }

  const { Goals: goals } = data;
  const { goalId } = useRouteParams();
  const goal = goals.find(({ GoalId }) => GoalId === goalId);
  const { Data: chartData, Title } = goal?.GoalCharts?.[0];

  return (
    <>
      {isFetching && <Spinner />}
      <Explanations selectedTab={CharitableGivingTab.Overview} my="24" />
      <Card mt="32">
        <Box p={16}>
          <Text variant="cardTitle" mb="24">
            {Title}
          </Text>

          <CharitableGivingChart ref={chartRef} data={chartData} />

          <Box display="flex" justifyContent="center">
            <LegendKey text="Donation Covered" />
            <LegendKey
              dotBorderColor="primary.500"
              dotColor="primary.100"
              ml="24"
              text="Donation Not Covered"
            />
          </Box>
        </Box>
      </Card>
    </>
  );
};
